import { createContext } from "react";
import { deleteAccessTokens } from "./api";

const AppContext = createContext();

const APP_INITIAL_SETTINGS = {
  navigation_collapsed : false,
  leads_mode           : 'list'  // ['kanban', 'list']
}

const initialLocalSettings = () => {
  const storedSettings = localStorage.getItem('pl__local_settings');

  if (storedSettings) {
    try {
      return JSON.parse(storedSettings);
    }
    catch {}
  }

  return APP_INITIAL_SETTINGS;
}

export const APP_INITIAL_STATE = {
  currentUser      : null,
  currentUserRole  : null,
  loggedIn         : null,
  globalToast      : null,
  localSettings    : initialLocalSettings(),
  colorTheme       : localStorage.getItem('pl__color_theme') || 'light',
};

export const appReducer = (draft, action) => {
  switch (action.type) {
    case 'loggedIn/set':
      draft.loggedIn = action.payload;
      break;

    case 'currentUser/setId':
      if (!draft.currentUser) {
        draft.currentUser = {};
      }

      draft.currentUser.id = action.payload;
      draft.loggedIn = true;
      break;

    case 'currentUser/set':
      draft.currentUser = action.payload;
      draft.loggedIn = true;
      break;

    case 'currentUserRole/set':
      draft.currentUserRole = action.payload;
      break;

    case 'currentUser/delete':
      draft.currentUser = null;
      draft.loggedIn = false;

      deleteAccessTokens();

      break;

    case 'globalToast/set':
      draft.globalToast = action.payload;
      break;

    case 'globalToast/clear':
      draft.globalToast = null;
      break;

    case 'localSettings/edit':
      const { setting, value } = action.payload;
      draft.localSettings[setting] = value;
      localStorage.setItem('pl__local_settings', JSON.stringify(draft.localSettings));
      break;

    case 'localSettings/clearAll':
      draft.localSettings = APP_INITIAL_SETTINGS;
      localStorage.setItem('pl__local_settings', JSON.stringify(draft.localSettings));
      break;

    case 'colorTheme/set':
      draft.colorTheme = action.payload;
      localStorage.setItem('pl__color_theme', action.payload);
      break;

    default:
      console.warn("Non-existing action type:", action.type);
  }
};

export default AppContext;
